import { Card, Checkbox, CssBaseline, Grid, Option, Select, Stack, Table, Typography } from "@mui/joy"
import { useState } from "react"
import { useSelector } from "react-redux"
import { Link, useSearchParams } from "react-router-dom"
import listaEstados from "./sku_estados"

function SkuSearchPage() {

    const [searchParams] = useSearchParams()
    var [estado, setEstado] = useState(searchParams.get("estado"))


    const [publicacao, setPublicacao] = useState({
        Amazon: true,
        OLX: true,
        Enjoei: true,
        EstanteVirtual: true,
        MercadoLivre: true,
        Shopee: true,
    });

    var livros = useSelector(state => state.livrudo.db.livros)
    var skus = useSelector(state => state.livrudo.db.skus)

    var resultados = [...skus].filter(e => {

        if (estado != "TODOS") {
            if (e.ultimoEstado != estado)
                return false
            if(estado == "ARMAZENADO_A_PUBLICAR") {
                var keys = Object.keys(publicacao)

                var keysToConsider = []
                for(var i = 0; i< keys.length;i++) {
                    if(publicacao[keys[i]]) keysToConsider.push(keys[i])
                }

                var not = false
                for(var i = 0; i< keysToConsider.length;i++) {
                    var toPublish = typeof(e.publicacao) != "undefined" && e.publicacao != null && e.publicacao[keysToConsider[i]].toPublish
                    var published = typeof(e.publicacao) != "undefined" && e.publicacao != null && e.publicacao[keysToConsider[i]].published
                    // var toPublish = false
                    // var published = false

                    if(toPublish && !published) {
                        not = true
                    }

                }

                return not
            }
        }

        return true;

    })

    var itensCount = resultados.length
    var itensSum = resultados.reduce((total, item) => total + parseFloat(item.preco), 0)

    resultados.sort((a, b) => new Date(b.data) - new Date(a.data));

    

    const togglePublicar = (target) => {
        var p = {...publicacao, [target] : !publicacao[target]}
        setPublicacao(p)
    }

    return (
        <Grid container sx={{ padding: 2, margin: 2 }}>
            <Grid xs={12}>
                <Typography level="h4" sx={{ marginBottom: 2 }}>
                    Dados dos Livros
                </Typography>
            </Grid>
            <Grid xs={12} sx={{padding: 2}}>
                <Stack direction="row">
                    <Select
                        value={estado}
                        onChange={(e, value) => setEstado(value)}
                    >
                        <Option value="TODOS">TODOS</Option>
                        {listaEstados
                            .map(l =>
                                <Option value={l}>{l}</Option>)}
                    </Select>
                </Stack>
            </Grid>
            <Grid xs={12} sx={{padding: 2}}>
                <Stack direction="row" spacing={2}>
                   <Typography>
                    <b>Itens:</b> {itensCount}
                   </Typography>
                   <Typography>
                    <b>Total: </b>R$ {itensSum.toFixed(2)}
                   </Typography>
                </Stack>
            </Grid>
            {estado == "ARMAZENADO_A_PUBLICAR" &&
                <Grid xs={12} sx={{padding: 1}}>
                    <Stack direction="row" spacing={2}>
                        <Checkbox
                            label="Amazon"
                            checked={publicacao["Amazon"]}
                            onChange={() => togglePublicar("Amazon")}
                            sx={{ ml: 2 }}
                        />
                        <Checkbox
                            label="OLX"
                            checked={publicacao["OLX"]}
                            onChange={() => togglePublicar("OLX")}
                            sx={{ ml: 2 }}
                        />
                        <Checkbox
                            label="Enjoei"
                            checked={publicacao["Enjoei"]}
                            onChange={() => togglePublicar("Enjoei")}
                            sx={{ ml: 2 }}
                        />
                        <Checkbox
                            label="MercadoLivre"
                            checked={publicacao["MercadoLivre"]}
                            onChange={() => togglePublicar("MercadoLivre")}
                            sx={{ ml: 2 }}
                        />
                        <Checkbox
                            label="Shopee"
                            checked={publicacao["Shopee"]}
                            onChange={() => togglePublicar("Shopee")}
                            sx={{ ml: 2 }}
                        />
                    </Stack>
                </Grid>}
            <Grid xs={12}>

                <Card>
                    <CssBaseline />
                    <Table sx={{ minWidth: '800px' }}>
                        <thead>
                            <tr>
                                <td style={{ width: "100px" }}>Data</td>
                                <td style={{ width: "120px" }}>SKU</td>
                                <td style={{ width: "400px" }}>Nome</td>
                                <td style={{ width: "300px" }}>Preço</td>
                                <td style={{ width: "180px" }}>Plataforma</td>
                                <td style={{ width: "180px" }}>Condição</td>
                                <td>Estado</td>
                            </tr>
                        </thead>
                        <tbody>
                            {resultados
                               
                                .map((item, index) => {

                                    var livro = livros.filter(l => l.id == item.livroId)[0]

                                    var preco = "R$ " + item.preco
                                    var plataforma = item.plataforma
                                    if (typeof (item.venda) != "undefined" && item.venda != null) {
                                        preco = "R$ " + item.preco + "/" + item.venda.preco
                                        preco += " (R$ " + item.venda.lucro.toFixed(2) + ")  (" + (item.venda.retorno * 100).toFixed(1) + "%)"

                                        plataforma += " / " + item.venda.plataforma
                                    }

                                    return (
                                        <tr key={index}>
                                            <td>{item.data}</td>
                                            <td>
                                                <Link to={"/livrudo/skus/" + item.sku}>
                                                    {item.sku}
                                                </Link>
                                            </td>
                                            <td>{livro.nome}</td>
                                            <td>{preco}</td>
                                            <td>{plataforma}</td>
                                            <td>{item.condicao}</td>
                                            <td>{item.ultimoEstado}</td>
                                        </tr>
                                    )

                                })}
                        </tbody>
                    </Table>
                </Card>
            </Grid>
        </Grid>
    );
};

export default SkuSearchPage